const isBetweenTwoDates = (date, start, end) => date >= start && date <= end

export default isBetweenTwoDates
